import React from 'react';

export default function MenuNav({ onNav, usuario }) {
  const logo = typeof window !== 'undefined' ? localStorage.getItem('logo_institucional') : '';
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary sticky-top py-1">
      <div className="container-fluid">
        <button className="navbar-toggler me-2 order-0" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav" aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <a className="navbar-brand d-flex align-items-center gap-2 order-1" href="#" onClick={e => { e.preventDefault(); onNav('kanban'); }}>
          {logo ? (
            <img src={logo} alt="Logo" style={{ width: 28, height: 28, objectFit: 'contain', borderRadius: 4, background: '#fff' }} />
          ) : null}
          <span>Fiscalia Militar</span>
        </a>
        <div className="collapse navbar-collapse order-2" id="mainNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('kanban'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-kanban" />
                <span>Kanban</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('registrar'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-person-plus" />
                <span>Registrar</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('acusados'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-people" />
                <span>Acusados</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('formatos'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-file-earmark-text" />
                <span>Formatos</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('reportes'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-graph-up" />
                <span>Reportes</span>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link d-flex align-items-center gap-2" href="#" onClick={e => { e.preventDefault(); onNav('config'); const c=document.getElementById('mainNav'); if(c?.classList.contains('show')) c.classList.remove('show'); }}>
                <i className="bi bi-gear" />
                <span>Configuración</span>
              </a>
            </li>
          </ul>
          <span className="navbar-text small">
            {usuario ? <>Bienvenido, <b>{usuario.usuario}</b></> : null}
          </span>
        </div>
      </div>
    </nav>
  );
}
